import { render, staticRenderFns } from "./wuxingzc.vue?vue&type=template&id=27ca2dfe&scoped=true&"
import script from "./wuxingzc.vue?vue&type=script&lang=js&"
export * from "./wuxingzc.vue?vue&type=script&lang=js&"
import style0 from "./wuxingzc.vue?vue&type=style&index=0&id=27ca2dfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ca2dfe",
  null
  
)

export default component.exports